import { createUrlRelativeToEnvironment } from "client_legacy/ndaw/navigator";
import { never } from "client_legacy/ndaw/errors";
import {
	CommunityDiscoveryListItem,
	CommunityMembershipStatus,
	CommunityVisibility,
	RequestToJoinCommunityResult
} from "client/Api/Communities/community";

export function getCommunityImageUrl(imageId: string): string {
	return createUrlRelativeToEnvironment(
		`/Hub/Communities/Image/?imageId=${encodeURIComponent(imageId)}`
	);
}

export enum CommunityJoinabilityKind {
	Member = 1,
	CanJoin = 2,
	CanRequestToJoin = 3,
	RequestPending = 4,
	CannotJoin = 5
}

export type NonMemberJoinabilityKind =
	| CommunityJoinabilityKind.CanJoin
	| CommunityJoinabilityKind.CanRequestToJoin
	| CommunityJoinabilityKind.CannotJoin;

export type VisibleCommunityJoinabilityKind =
	| CommunityJoinabilityKind.Member
	| CommunityJoinabilityKind.CanJoin
	| CommunityJoinabilityKind.CanRequestToJoin
	| CommunityJoinabilityKind.RequestPending;

export function getCommunityJoinabilityKind(
	community: CommunityDiscoveryListItem
): VisibleCommunityJoinabilityKind {
	const { userInfo } = community;

	switch (userInfo.membershipStatus) {
		case CommunityMembershipStatus.Member:
			return CommunityJoinabilityKind.Member;
		case CommunityMembershipStatus.RequestPending:
			return CommunityJoinabilityKind.RequestPending;
		case CommunityMembershipStatus.NotMember:
			return userInfo.canAccess
				? CommunityJoinabilityKind.CanJoin
				: CommunityJoinabilityKind.CanRequestToJoin;
		default:
			never(userInfo.membershipStatus);
	}
}

export function getJoinabilityKindAfterLeaving(
	community: CommunityDiscoveryListItem
): NonMemberJoinabilityKind {
	const {
		visibility,
		userInfo
	} = community;

	return getNonMemberJoinabilityKind(visibility, userInfo.canAccessWithoutMembership);
}

export const requestToJoinResultToMembershipStatusMap: Record<RequestToJoinCommunityResult, CommunityMembershipStatus> = {
	[RequestToJoinCommunityResult.Created]: CommunityMembershipStatus.RequestPending,
	[RequestToJoinCommunityResult.AlreadyPending]: CommunityMembershipStatus.RequestPending,
	[RequestToJoinCommunityResult.AlreadyMember]: CommunityMembershipStatus.Member
};

function getNonMemberJoinabilityKind(
	visibility: CommunityVisibility,
	canAccess: boolean
): NonMemberJoinabilityKind {
	if (canAccess) {
		return CommunityJoinabilityKind.CanJoin;
	}

	switch (visibility) {
		case CommunityVisibility.Public:
			return CommunityJoinabilityKind.CanJoin;
		case CommunityVisibility.Private:
			return CommunityJoinabilityKind.CanRequestToJoin;
		case CommunityVisibility.Hidden:
			return CommunityJoinabilityKind.CannotJoin;
		default:
			never(visibility);
	}
}
